import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/daiban_ic_daiban@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-57845808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "类型", -1))
const _hoisted_4 = { class: "Search_item_content" }
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_h" }, null, -1))
const _hoisted_9 = { class: "box_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list_item_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "box_list_item_nr" }
const _hoisted_13 = { class: "box_list_item_nr_top" }
const _hoisted_14 = { class: "box_list_item_nr_bottom" }

import { reactive, ref, onMounted, onActivated, getCurrentInstance } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex'
    import { judgmentPlatform } from "@/utils/utils"
    import { getList, pageCount } from '@/apis/agencyAPI'
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'
    // import vTransverseDiagram from '@/components/chart/TransverseDiagram.vue'
    // import vHistogram from '@/components/chart/Histogram.vue'
    // import vPieChart from '@/components/chart/PieChart.vue'

    interface pageVerify extends model {
        model?: {
            status: number | string,
            type: number | string,
            mixParam: number | string
        }
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()

    const router = useRouter()
    const store = useStore()
    let list: any = ref([])    // 列表数据
    let one = ref<boolean>(false)
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    let page: any = reactive<pageVerify>({
        capacity: 10,
        page: 0,
        model: {
            status: 0,
            type: '',
            mixParam: ''
        }
    })

    let status = ref<boolean>(true)    // 根据平台是否需要设置top

    let data: any = ref([
        {
            id: 0,
            name: '车间领料-待发货',
            isActive: false
        },
        {
            id: 1,
            name: '车间领料-待入库',
            isActive: false
        },
        {
            id: 2,
            name: '机台备料-待发货',
            isActive: false
        },
        {
            id: 3,
            name: '机台备料-待入库',
            isActive: false
        },
        {
            id: 4,
            name: '完工入库-待接收',
            isActive: false
        },
        {
            id: 5,
            name: '库存转库-待发货',
            isActive: false
        },
        {
            id: 6,
            name: '库存转库-待入库',
            isActive: false
        },
        {
            id: 7,
            name: '申请审批',
            isActive: false
        },
        {
            id: 8,
            name: '客退/返品回厂检验',
            isActive: false
        }
    ]) // 搜索项类型数据

    let tagList: any = reactive([
        {
            id: 0,
            name: '待办',
            num: 0
        },
        {
            id: 1,
            name: '已办',
            num: 0
        }
    ])  // 搜索分类标签

    const reset = () => {
        page.model.mixParam = ''
        finished.value = false
        page.page = 0
        page.model.type = ''
        list.value = []
        data.value.forEach((item: any) => {
            item.isActive = false
        })
        onLoad()
    }

    const searchInput = (name: string) => {   // 搜索数据
        page.model.mixParam = name
        finished.value = false
        page.page = 0
        list.value = []
        onLoad()
    }

    const clickTag = (id: any): void => {   // 切换分类
        page.model.status = id
        finished.value = false
        page.page = 0
        list.value = []
        onLoad()
    }

    const submit = () => {    // 搜索项点击提交
        let isOpen: boolean = true
        data.value.forEach((item: any) => {
            if (item.isActive) {
                isOpen = false
                page.model.type = item.id
                finished.value = false
                page.page = 0
                list.value = []
                onLoad()
                return
            }
        })
        if (isOpen) {
            isOpen = false
            page.model.type = ''
            finished.value = false
            page.page = 0
            list.value = []
            onLoad()
        }
    }

    // 点击切换类型
    const changeTag = (i: number): void => {
        data.value.forEach((item: any, index: number) => {
            if (i === index) {
                item.isActive = !item.isActive
            } else {
                item.isActive = false
            }
        })

    }

    // 调转详情
    const jump = (item: any) => {
        if ((item.type === 0 || item.type === 2 || item.type === 5) && item.status === 0) {  // 跳转出库(转库单)
            router.push({ name: 'issueOperation', query: { id: item.objId, dbid: item.id, type: 7 } })
        } else if ((item.type === 0 || item.type === 2 || item.type === 5) && item.status === 1) {
            router.push({ name: 'wTransferDetail', query: { id: item.objId, status: item.status, type: item.type, dbid: item.id } })
            // router.push({ name: 'wTransferDetail', query: { id: item.objId, status: 0, type: item.type, dbid: item.id } })
        } else if ((item.type === 1 || item.type === 4 || item.type === 6) && item.status === 0) {  // 跳转入库(转库单)
            if (item.type === 4) {  // 跳转完工入库详情
                router.push({ name: 'completionDetails', query: { id: item.objId, dbid: item.id, type: 7, isShow: 1, Type: item.type } })
                return
            }
            router.push({ name: 'warehousing', query: { id: item.objId, dbid: item.id, type: 7 } })
        } else if ((item.type === 1 || item.type === 4 || item.type === 6) && item.status === 1) {
            if (item.type === 4) {  // 跳蛛完工入库详情
                router.push({ name: 'completionDetails', query: { id: item.objId, dbid: item.id, type: 7, isShow: 2 } })
                return
            }
            router.push({ name: 'wTransferDetail', query: { id: item.objId } })
        } else if (item.type === 3 && item.status === 0) {   // 确认备料
            router.push({ name: 'orderStock', query: { id: item.objId, dbid: item.id } })
        } else if (item.type === 3 && item.status === 1) {   // 备料（转库单详情）
            // router.push({ name: 'wInboundDetail', query: { id: item.objId } })
            router.push({ name: 'wTransferDetail', query: { id: item.objId } })
        } else if (item.type === 9 && item.status === 0) {   // 调整入库(入库单)
            router.push({ name: 'warehousing', query: { id: item.objId, dbid: item.id, type: 9 } })
        } else if (item.type === 9 && item.status === 1) {
            router.push({ name: 'wInboundDetail', query: { id: item.objId } })
        }
    }

    // 列表数据
    const onLoad = () => {
        if (!finished.value && one.value) {
            loading.value = true
            page.page = page.page + 1
            getList(page).then(res => {
                loading.value = false
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
            }).catch(err => {
                refreshing.value = false
                loading.value = false
                finished.value = true
            }).finally(() => {
                loading.value = false
            })
        }
        one.value = true
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        page.page = 0
        finished.value = false;
        loading.value = true;
        // pageCounts()
        store.dispatch('getUpcomingNum')
        onLoad()
    }

    // 统计数量
    // const pageCounts = () => {
    //     pageCount({})
    //         .then(res => {
    //             if (res.code === 200) {
    //                 tagList[0].num = res.data.startNum
    //                 tagList[1].num = res.data.endNum
    //             }
    //         })
    // }

    onMounted(async () => {
        await proxy.$onWait;
        onLoad()
        // pageCounts()
        // await store.dispatch('getUpcomingNum')
        // tagList[0].num = store.state.upcomingNum.d
        // tagList[1].num = store.state.upcomingNum.y
        status.value = judgmentPlatform()
    })

    onActivated(async() => {
        await proxy.$onWait;
        await store.dispatch('getUpcomingNum')
        tagList[0].num = store.state.upcomingNum.d
        tagList[1].num = store.state.upcomingNum.y
    })

// const info = reactive({
//     list: []
// })
//
// const arrs = reactive<Array<object>>([
//     {
//         id: 1,
//         name: 'WL0001 | 物料名称1',
//         num: 1000
//     },
//     {
//         id: 2,
//         name: 'WL0001 | 物料名称2',
//         num: 900
//     },
//     {
//         id: 3,
//         name: 'WL0001 | 物料名称3',
//         num: 800
//     },
//     {
//         id: 4,
//         name: 'WL0001 | 物料名称4',
//         num: 700
//     }
// ])
//
// const PieChartLegendData = reactive<Array<{name: string, icon: string}>>([
//     {
//         name: '其它问题',
//         icon: 'circle',
//     },
//     {
//         name: '生产问题',
//         icon: 'circle',
//     },
//     {
//         name: '机器问题',
//         icon: 'circle',
//     },
//     {
//         name: '上道工序问题',
//         icon: 'circle',
//     },
//     {
//         name: '管理问题',
//         icon: 'circle',
//     }
// ])
//
// const PieChartSeriesData = reactive<Array<any>>([
//     {
//         value: 500,
//         name: "其它问题",
//         itemStyle: { normal: { color: "#BDBDBD" } }
//     },
//     {
//         value: 42,
//         name: "生产问题",
//         itemStyle: { normal: { color: "#4275FC" } }
//     },
//     {
//         value: 175,
//         name: "机器问题",
//         itemStyle: { normal: { color: "#32CC93" } }
//     },
//     {
//         value: 145,
//         name: "上道工序问题",
//         itemStyle: { normal: { color: "#FAC02A" } }
//     },
//     {
//         value: 342,
//         name: "管理问题",
//         itemStyle: { normal: { color: "#E46456" } }
//     }
// ])
//
// const HistogramLegendData = reactive<Array<{name: string, icon: string}>>([
//     {
//         name: '计划量',
//         icon: 'circle',
//     },
//     {
//         name: '不量数',
//         icon: 'circle',
//     },
//     {
//         name: '合格数',
//         icon: 'circle',
//     }
// ])
//
// const HistogramSeriesData = reactive<Array<any>>([
//     {
//         name: '计划量',
//         type: 'bar',
//         stack: 'total',
//         zlevel: 1,
//         barWidth: 15,
//         itemStyle: {
//             color: '#4275FC'
//         },
//         emphasis: {
//             focus: 'series'
//         },
//         data: [320, 302, 301, 334, 390, 330, 320, 390, 330, 320]
//     },
//     {
//         name: '不量数',
//         type: 'bar',
//         stack: 'total',
//         barWidth: 15,
//         itemStyle: {
//             color: '#E46456'
//         },
//         emphasis: {
//             focus: 'series'
//         },
//         data: [120, 132, 101, 134, 90, 230, 210, 390, 330, 320]
//     },
//     {
//         name: '合格数',
//         type: 'bar',
//         stack: 'total',
//         barWidth: 15,
//         itemStyle: {
//             color: '#EFEFEF',
//             barBorderRadius: [10, 10, 0, 0]
//         },
//         emphasis: {
//             focus: 'series'
//         },
//         data: [220, 182, 191, 234, 290, 330, 310, 390, 330, 320]
//     }
// ])
//
// const xAxisData = reactive<Array<string>>(['注射', '催脱', '高排', '烧结', '整形', '机加', '外观', '振光', '酸洗', '成品'])

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        placeholder: "搜索关键字",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: i,
                    onClick: ($event: any) => (changeTag(i))
                  }, _toDisplayString(item.name), 11, _hoisted_6))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _hoisted_7,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _hoisted_8,
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "box_list_item",
                  key: index,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1),
                      _createElementVNode("span", null, _toDisplayString(item.createTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.content), 1)
                  ])
                ], 8, _hoisted_10))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})